import React from "react";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import { FieldError, TextField } from "../../common/fields";
import { isNativeApp } from "../../../utils"
import { Link, Typography, Button, ButtonGroup } from "@one-thd/sui-atomic-components";
import { selectAutomationIdBasedOnComponent } from "../../../utils/automationIds";

const dataAutomationIds = {
  "email": "edit-phone-modal--link-email-me-a-new-code",
  "sms": "edit-phone-modal--link-text-me-a-new-code",
  "phone": "edit-phone-modal--link-phone-me-a-new-code",
}

const OtpTextBox = (props) => {
  const {
    emailEditContext,
    onCancelModal,
    onSubmitCallback,
    errorState,
    currentView,
    setCurModalView,
    onClickOptions,
    origin,
    OtpTextLinkOptionsComponent,
    isVerifyingANewPhone=false,
    textMeANewCodeAfterVerifyingIdentity,
    phoneMeANewCodeAfterVerifyingIdentity,
    navigateToModal,
    verifyExistingPhone,
    isPhoneVerified=false,
  } = props;

  const verifyOtpForm = useFormik({
    initialValues: {
      otp: "",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    validate: ((values) => {
      const errors = {};
      errors.otp = [];
      if (values.otp.length === 0) {
        errors.otp.push("Please enter your six digit code.");
      } else if (values.otp.length <= 5 && values.otp.length >= 1) {
        errors.otp.push("The verification code must be 6 digits");
      }
      return !isEmpty(errors.otp) && errors;
    }),

    onSubmit: (values) => {
      const { otp } = values;
      onSubmitCallback(otp);
    },
  });

  const cleanupForm = (callback) => {
    verifyOtpForm.resetForm();
    if (callback) {
      callback(emailEditContext);
    }
  };

  const onModalClose = () => cleanupForm(onCancelModal);

  const onOtpChange = (e) => {
    const otp = e.target.value.trim().replace(/[^\d]/, "");
    verifyOtpForm.setFieldValue("otp", otp, true);
  };

  const resendNewCodeForOTPOptionsAndSetView = (view, otpChoice, origin) => {
    setCurModalView(view);
    onClickOptions(otpChoice, origin);

  }

  const getCurrentViewAndOrder = (view) => {
    const emailOrder = {
      textOrder: ["Email me a new code", "Text me a new code", "Call me with a new code"],
      setViewOrder: ["email", "newPhoneVerificationSms", "newPhoneVerificationEvoice"],
      otpChoice: ["email", "sms", "phone"],
    };
    const callOrder = {
      textOrder: ["Call me with a new code", "Text me a new code", "Email me a new code"],
      setViewOrder: ["newPhoneVerificationEvoice", "newPhoneVerificationSms", "email"],
      otpChoice: ["phone", "sms", "email"],
    };
    const textOrder = {
      textOrder: ["Text me a new code", "Call me with a new code", "Email me a new code"],
      setViewOrder: ["newPhoneVerificationSms", "newPhoneVerificationEvoice", "email"],
      otpChoice: ["sms", "phone", "email"],
    };
    if (view === "email") {
      return emailOrder;
    }else if(view === "sms"){
      return textOrder;
    }else if (view === "phone"){
      return callOrder;
    }

    return emailOrder;
  }

  //todo refactor this and make them their own components
  const UPDATE_EMAIL_ORIGIN = "emailEdit";
  const UPDATE_PHONE_ORIGIN = "phoneEdit";
  const VERIFY_EXISTING_PHONE = "verifyExistingPhone";

  const ORIGIN_MAP = {
    "emailEdit": UPDATE_EMAIL_ORIGIN,
    "phoneEdit": UPDATE_PHONE_ORIGIN,
    "verifyExistingPhone": VERIFY_EXISTING_PHONE
  }

  const currentOrder = getCurrentViewAndOrder(currentView);

  const selectedFlow = (origin in ORIGIN_MAP) ? ORIGIN_MAP[origin] : "";

  function getAction(component) {
    let verifyAction = "verify";
    if(!isVerifyingANewPhone && (origin===UPDATE_PHONE_ORIGIN) && (component==="verify")) {
      verifyAction = "verifyIdentity";
    }

    return component==="verify" ? verifyAction : "cancel";
  }

  return (
    <div className="sui-grid sui-gap-4">
      <div className="sui-mt-4">
        <TextField
          maxLength={6}
          autoFocus={ !isNativeApp() } // eslint-disable-line
          className="no-padding-sides otp-text-box sui-text-base"
          id="verifyOTP_EmailEdit"
          name="otp"
          dataAutomationId="login-information-email-form--edit-email-otp-submit-button"
          type="OTP"
          label="Enter Verification Code"
          valid={!(verifyOtpForm.touched.otp && !isEmpty(verifyOtpForm.errors.otp))}
          onChange={onOtpChange}
          onBlur={verifyOtpForm.handleBlur}
          value={verifyOtpForm.values.otp}
        >
          {!isEmpty(errorState)
            && (
              <div className="col__12-12 no-padding-sides form-input--error">
                <FieldError name="otp" errors={errorState}/>
              </div>
            )}
        </TextField>
      </div>
      {(origin === UPDATE_EMAIL_ORIGIN) &&
        <div>
          <div>
            <Typography>Didn&apos;t received a code?</Typography>
          </div>
          {currentOrder.textOrder.map( (elements, index) => (
            <div key={index}>
              <Link data-automation-id={dataAutomationIds[currentOrder.otpChoice[index]]} className="sui-block sui-font-regular sui-text-base sui-tracking-normal sui-normal-case sui-line-clamp-none sui-text-primary focus-visible:sui-bg-focus focus-visible:sui-outline-none sui-underline sui-my-4"
              onClick={() =>  resendNewCodeForOTPOptionsAndSetView(currentOrder.setViewOrder[index], currentOrder.otpChoice[index])  }>
              {elements}
              </Link>
            </div>
          ))
          }
        </div>
      }

      {( origin === UPDATE_PHONE_ORIGIN && isPhoneVerified && !isVerifyingANewPhone  ) &&
      // Verified Phone Flow. Resend Options for Verifying Identity
        <OtpTextLinkOptionsComponent
            origin={origin}
            resendNewCodeForOTPOptionsAndSetView={resendNewCodeForOTPOptionsAndSetView}
            isVerifyingUsersIdentity
            currentView={currentView}
            isPhoneVerified={isPhoneVerified}
        />
      }

      {origin === UPDATE_PHONE_ORIGIN && !isPhoneVerified && !isVerifyingANewPhone &&
      // Unverified Phone Flow. Resend Options for Verifying Identity
        <div className="sui-flex">
          <Link data-automation-id={selectAutomationIdBasedOnComponent("phone", "resendEmailIdentity")} onClick={()=>{ resendNewCodeForOTPOptionsAndSetView("email", "email", origin) }}> Resend the email message </Link>
        </div>
      }
      { isVerifyingANewPhone && (origin===UPDATE_PHONE_ORIGIN) && <OtpTextLinkOptionsComponent
                                            phoneMeANewCode={phoneMeANewCodeAfterVerifyingIdentity}
                                            textMeANewCode={textMeANewCodeAfterVerifyingIdentity}
                                            navigateToModal={navigateToModal}
                                            currentView={currentView}
                                            isPhoneVerified={isPhoneVerified}
                                            isVerifyingANewPhone={isVerifyingANewPhone}
                                            /> }

      { (origin===VERIFY_EXISTING_PHONE) && <OtpTextLinkOptionsComponent
                                                        currentView={currentView}
                                                        navigateToModal={navigateToModal}
                                                        verifyExistingPhone={verifyExistingPhone}
                                                        isVerifyingExistingPhone /> }
      <ButtonGroup fullWidth orientation="vertical">
          <Button type="submit"
            data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, getAction("verify"), isPhoneVerified)}
            variant="primary"
            onClick={verifyOtpForm.handleSubmit}
            disabled={!verifyOtpForm.isValid}>
            Verify
          </Button>
          <Button
            data-automation-id={selectAutomationIdBasedOnComponent(selectedFlow, getAction("cancel"), isPhoneVerified)}
            variant="secondary"
            onClick={onModalClose}>
              Cancel
          </Button>
      </ButtonGroup>
    </div>
  );
};

export default OtpTextBox;
